import moment from 'moment';

const isPurchaseAllocated = (
  { line_items = [], status },
  invalidStatus = null,
) => {
  if (invalidStatus && invalidStatus.includes(status)) {
    return true;
  }
  return line_items
    .map(
      (line) =>
        line.hasOwnProperty('from_date') && line.hasOwnProperty('to_date'),
    )
    .includes(true);
};

const isAllocatedAfterCurrentCycle = ({ line_items = [] }, { current }) => {
  const lines = line_items
    .filter((item) => item.hasOwnProperty('from_date'))
    .map((item) => moment(item.from_date).isAfter(current.end_date));
  return lines.length === 0 || lines.includes(true);
};

export const canAdjust = (purchase) =>
  isPurchaseAllocated(purchase) && purchase.status === 'overdue';

export const canCancel = (purchase, cycles) => {
  if (!cycles) {
    return false;
  }

  if (!['pending', 'overdue', 'open'].includes(purchase.status)) {
    return false;
  }

  const unallocated = !isPurchaseAllocated(purchase);
  return unallocated || isAllocatedAfterCurrentCycle(purchase, cycles);
};

export const canCharge = (purchase) =>
  !!['pending', 'overdue', 'preauth', 'arranged', 'open'].find((status) =>
    status.includes(purchase.status),
  );

export const PER_PAGE = 20;
